<template>
  <div id="app">
    <img
      v-if="imageUrl"
      :src="imageUrl"
      alt="Loaded from API"
      @click="openFilePicker"
    />
    <p v-if="error" class="error">{{ error }}</p>

    <div v-if="isEditing">
      <image-uploader
        :entity-id="teamId==null?0:teamId"
        :showModal="showModal"
        @imageChanged="onImageChanged"
        @closeModal="showModal = false"
      />
    </div>
  </div>
</template>

<script>
import { getTeamImage } from '@/api/team.js';
import ImageUploader from '@/components/common/ImageUploader.vue';
import { getActivityImage } from '../../api/activity';

export default {
  name: 'TeamImage',
  props: {
    teamId: {
      type: Number,
      required: false,
    },
    activityId: {
      type: Number,
      required: false,
    },
    isEditing: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    ImageUploader,
  },

  emits: ['imageChanged'],
  
  data() {
    return {
      imageUrl: null, // Holds the object URL for the image
      error: null, // Holds any error messages
      showModal: false, // Controls visibility of the "Load Image" modal
    };
  },

  methods: {
    async fetchImage() {
      try {
        const { teamId } = this;

        // Fetch image data as a Blob from the API
        const imageBlob = 
              (teamId == null || teamId == 0 || teamId === undefined) ?
                await getActivityImage(this.activityId) :
                await getTeamImage({ teamId });

        // Revoke any previous object URL to avoid memory leaks
        if (this.imageUrl) {
          URL.revokeObjectURL(this.imageUrl);
        }

        // Create an object URL from the Blob and assign it to imageUrl
        this.imageUrl = URL.createObjectURL(imageBlob);
      } catch (error) {
        console.error('Error fetching the image:', error);
        this.error = 'Failed to load image. Please try again.';
      }
    },

    openFilePicker() {
      // Open the modal popup when the image is clicked
      this.showModal = true;
      this.error = null;
    },

    onImageChanged(selectedFile) {
      // Handle the updated image URL
      if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl); // Revoke old object URL
      }
      this.imageUrl = URL.createObjectURL(selectedFile); // Assign the new image URL
      this.selectedFile = selectedFile;
      this.$emit('imageChanged', selectedFile);
    },
  },

  created() {
    this.fetchImage();
  },

  beforeUnmount() {
    // Revoke the object URL when the component is destroyed
    if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
    }
  },
};
</script>

<style scoped>
.profile-image {
  cursor: pointer;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
}

.error {
  color: red;
  font-size: 14px;
  margin-top: 10px;
}
</style>
